import * as React from 'react';
import { Input } from '@/lib/components/ui/input';
import { Label } from '@/lib/components/ui/label';

interface InputWithLabelProps extends React.ComponentProps<typeof Input> {
  label: string | React.ReactNode;
  error?: string;
  descriptionText?: string;
}

const InputWithLabel = React.forwardRef<HTMLInputElement, InputWithLabelProps>(
  ({ label, error, descriptionText, className, ...rest }, ref) => {
    return (
      <div className="grid w-full gap-1.5">
        {typeof label === 'string' ? (
          <Label htmlFor={rest.id || rest.name}>{label}</Label>
        ) : (
          label
        )}
        <Input
          ref={ref}
          className={
            error ? 'border-red-500 focus-visible:ring-red-500' : className
          }
          {...rest}
        />
        {(error || descriptionText) && (
          <p
            className={`text-xs ${error ? 'text-red-500' : 'text-muted-foreground'}`}
          >
            {error || descriptionText}
          </p>
        )}
      </div>
    );
  }
);

InputWithLabel.displayName = 'InputWithLabel';

export default InputWithLabel;
